import { render, staticRenderFns } from "./WorldSpiaggeLogin.vue?vue&type=template&id=d5fcbefa&scoped=true&"
import script from "./WorldSpiaggeLogin.vue?vue&type=script&lang=js&"
export * from "./WorldSpiaggeLogin.vue?vue&type=script&lang=js&"
import style0 from "./WorldSpiaggeLogin.vue?vue&type=style&index=0&id=d5fcbefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../food/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fcbefa",
  null
  
)

export default component.exports